import { Component, OnInit, ViewChild } from '@angular/core';
import {ColumnMode, SortType} from "@swimlane/ngx-datatable";
import { HttpClient } from "@angular/common/http";
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { IonModal } from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { DataService } from '../data.service';

@Component({
  selector: 'app-faliujsag',
  templateUrl: './faliujsag.component.html',
  styleUrls: ['./faliujsag.component.scss'],
})
export class FaliujsagComponent  implements OnInit {

  faliujsag
  githubUsers
    selectedUsers = [];
    veglegesLista=[];
  
  bejovo=[];
  kimeno=[];
  draft=[];
  targy=""
  uzenet=""
  menu="default"
  userMetadata
  @ViewChild("uzenetmodal") modal: IonModal;
  @ViewChild("csoportmodal") csoportmodal: IonModal;
  fg: UntypedFormGroup = new UntypedFormGroup({
    state: new UntypedFormControl(),
});
  protected readonly ColumnMode = ColumnMode;
  protected readonly SortType = SortType;
  cimzett = "0"
  sajatIntezmeny
  csoport;
  prioritas=2
  hatarido=null
  megnyitott = false;
  prio = ["","Alacsony","Normál","Fontos","Sűrgős"]
  


  constructor(private http: HttpClient,private dataService: DataService,) { }

  async ngOnInit() {
    this.userMetadata = (await this.dataService.getFromStorage("userMetadata"))
    this.sajatIntezmeny = (await this.dataService.getFromStorage("sajatIntezmeny"))
    this.getFaliujsag()
  }

  getFaliujsag(){
    let headers={
      intezmeny: this.sajatIntezmeny.intezmenyId
    }
    this.http
      .get(
        '/api/nyilvantartas/faliujsag',
        {
          headers: headers,
        }
      )
      .subscribe({
        next: (response) => {
          this.faliujsag = response
          console.log(this.faliujsag)
        },
        error: (error) => {
          console.error('Error fetching data:', error);

        },
      });
      this.http
        .get(
          '/api/nyilvantartas/csoport/'+this.sajatIntezmeny.intezmenyId,
          {
            headers: headers,
          }
        )
        .subscribe({
          next: (response) => {
            this.csoport = response
            console.log(this.csoport)
          },
          error: (error) => {
            console.error('Error fetching data:', error);
  
          },
        });
  }
  onActivate(event){
    if(event.type == 'click') {
      console.log(event.row);
      this.megnyitott = true;
      this.targy = event.row.name
      this.prioritas = event.row.priority
      this.uzenet = event.row.message
      this.hatarido = event.row.deadline

      this.initModal();
  }
  }

  getRowClass = (row) => {
    return {
      'row-color-blue': row.priority == 1,
      'row-color-green': row.priority == 2,
      'row-color-orange': row.priority == 3,
      'row-color-red': row.priority == 4,
    };
  }

  protected readonly JSON = JSON;


  onWillDismiss(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    if (ev.detail.role === 'confirm') {
    }
  }
  cancel() {
    this.modal.dismiss(null, 'cancel');
  }
  confirm(draft=0) {
    let body={
      //cimzettek: this.veglegesLista,
      name: this.targy,
      message: this.uzenet,
      user: this.userMetadata.adid,
      priority: this.prioritas,
      deadline: this.hatarido,
      csoport: this.cimzett,
      intezmeny: this.sajatIntezmeny.intezmenyId
    }
    this.http.post("/api/faliujsag/send", body).subscribe(d=>{
      //alert("Üzenet elküldve!")
      this.dataService.getFaliujsag(this.sajatIntezmeny.intezmenyId).subscribe(data => this.faliujsag=data);
      this.modal.dismiss()
    });
    
  }
  validateForm() {
    return false
  }
  initModal(r=0){
    if(r==1){
    this.megnyitott = false;
      this.targy = ""
      this.prioritas = 1
      this.uzenet = ""
      this.hatarido = ""}
    this.modal.present();
  }

  print() {
    console.log('FormControl', this.fg.value);
}
formData() {
  return {
      state: ['CA', 'NV'],
  };
}
resetForm() {
  this.fg.reset(this.formData());
}
openCsoport(){
this.csoportmodal.present()
}

add(){
  this.selectedUsers.forEach(item => {
    if (!this.veglegesLista.some(vegItem => vegItem.adid === item)) {
      const gitem = this.githubUsers.find(g => g.adid === item);
      if (gitem) {
        this.veglegesLista.push(gitem);
      } else {
        // Handle the case where the gitem is not found, if needed
      }
    }
  });
 // this.veglegesLista = [...this.veglegesLista, ...this.selectedUsers];
  this.selectedUsers = []
}
deleteItemFromLista(index: number): void {
  if (index >= 0 && index < this.veglegesLista.length) {
    this.veglegesLista.splice(index, 1);
  } else {
    console.error('Index out of bounds');
  }
}



files: any[] = [];

  /**
   * on file drop handler
   */
  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  /**
   * handle file from browsing
   */
  fileBrowseHandler(event) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files) {
      const files:any = inputElement.files;
      // Now you can handle the files as needed
      this.prepareFilesList(files);
    }
    
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.files.splice(index, 1);
  }

  /**
   * Simulate the upload process
   */
  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  /**
   * Convert Files list to normal array list
   * @param files (Files List)
   */
  prepareFilesList(files: Array<any>) {
    for (const item of files) {
      item.progress = 0;
      this.files.push(item);
    }
    this.uploadFilesSimulator(0);
  }

  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals=2) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


}
